/* eslint-disable no-else-return */
export const getDeviceSchema = () => [
    {
        attribute: 'advertisingIdentifier',
        label: 'advertisingIdentifier',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'appBadgeNumber',
        label: 'appBadgeNumber',
        __typename: 'NumberPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'appBuild',
        label: 'appBuild',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'appIdentifier',
        label: 'appIdentifier',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'appVersion',
        label: 'appVersion',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'buildEnvironment',
        label: 'buildEnvironment',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'carrierName',
        label: 'carrierName',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'conversions',
        label: 'conversions',
        __typename: 'StringArrayPredicate',
        selector: 'DEVICE',
        popularStringOption: false,
        group: 'devices',
    },
    {
        attribute: 'deviceIdentifier',
        label: 'deviceIdentifier',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'deviceManufacturer',
        label: 'deviceManufacturer',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'deviceModel',
        label: 'deviceModel',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'deviceName',
        label: 'deviceName',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'isBluetoothEnabled',
        label: 'isBluetoothEnabled',
        __typename: 'BooleanPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'isCellularEnabled',
        label: 'isCellularEnabled',
        __typename: 'BooleanPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'isDarkModeEnabled',
        label: 'isDarkModeEnabled',
        __typename: 'BooleanPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'isLocationServicesEnabled',
        label: 'isLocationServicesEnabled',
        __typename: 'BooleanPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'isTestDevice',
        label: 'isTestDevice',
        __typename: 'BooleanPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'isWifiEnabled',
        label: 'isWifiEnabled',
        __typename: 'BooleanPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'localeLanguage',
        label: 'localeLanguage',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'localeRegion',
        label: 'localeRegion',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'localeScript',
        label: 'localeScript',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'location.address.city',
        label: 'address.city',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'location',
    },
    {
        attribute: 'location.address.country',
        label: 'address.country',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'location',
    },
    {
        attribute: 'location.address.isoCountryCode',
        label: 'address.isoCountryCode',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.address.postalCode',
        label: 'address.postalCode',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.address.state',
        label: 'address.state',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'location',
    },
    {
        attribute: 'location.address.street',
        label: 'address.street',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.address.subAdministrativeArea',
        label: 'address.subAdministrativeArea',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.address.subLocality',
        label: 'address.subLocality',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.altitude',
        label: 'altitude',
        __typename: 'FloatPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.coordinate',
        label: 'coordinate',
        __typename: 'GeofencePredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.dmaCode',
        label: 'dmaCode',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.horizontalAccuracy',
        label: 'horizontalAccuracy',
        __typename: 'FloatPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.timestamp',
        label: 'timestamp',
        __typename: 'DatePredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'location.verticalAccuracy',
        label: 'verticalAccuracy',
        __typename: 'FloatPredicate',
        selector: 'DEVICE',
        group: 'location',
    },
    {
        attribute: 'locationAuthorization',
        label: 'locationAuthorization',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'notificationAuthorization',
        label: 'notificationAuthorization',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'operatingSystemName',
        label: 'operatingSystemName',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'operatingSystemVersion',
        label: 'operatingSystemVersion',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'pushToken.timestamp',
        label: 'pushToken.timestamp',
        __typename: 'DatePredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'pushToken.value',
        label: 'pushToken.value',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'radio',
        label: 'radio',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'screenHeight',
        label: 'screenHeight',
        __typename: 'NumberPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'screenWidth',
        label: 'screenWidth',
        __typename: 'NumberPredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'sdkVersion',
        label: 'sdkVersion',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'timeZone',
        label: 'timeZone',
        __typename: 'StringPredicate',
        selector: 'DEVICE',
        popularStringOption: true,
        group: 'devices',
    },
    {
        attribute: 'createdAt',
        label: 'firstSeen',
        __typename: 'DatePredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
    {
        attribute: 'lastSeen',
        label: 'lastSeen',
        __typename: 'DatePredicate',
        selector: 'DEVICE',
        group: 'devices',
    },
]

export const getDeviceLabel = attribute => {
    const findLabel = property => property.attribute === attribute
    const obj = getDeviceSchema().find(findLabel)
    if (obj) {
        return obj.label
    } else {
        return attribute
    }
}

export const getDeviceOptions = attribute => {
    const obj = getDeviceSchema().find(device => attribute === device.attribute)
    if (obj) {
        return obj.options
    }
    return undefined
}

export const getDeviceNeedsPopularStringOptions = attribute => {
    const obj = getDeviceSchema().find(device => attribute === device.attribute)
    if (obj) {
        return obj.popularStringOption
    }
    return undefined
}
